import {PRODUCTION} from './production'
import {TESTING} from './testing'

export const YANGO = {production: PRODUCTION, testing: TESTING}
